import * as React from 'react';
var PageContext = React.createContext(null);
PageContext.displayName = 'PageContext';
export default PageContext;
